import * as Scrivito from "scrivito";

const CollapseWidget = Scrivito.provideWidgetClass("CollapseWidget", {
  attributes: {
    panels: ["widgetlist", { only: ["TextPanelWidget"] }],
  },
  extractTextAttributes: ["panels"],
});

export default CollapseWidget;
